const DefaultSizes = ['6 inch', '16 inch', '32 inch'];
export default DefaultSizes;
